import { Planning } from '../progress-accordions/Planning';
import { Action } from '../progress-accordions/Action';
import { Reflect } from '../progress-accordions/Reflect';
import { ProgressStepStatusEnum, TeamProjectHubResponse } from '@platform/client/schemas';
import { HubProgressHeader } from '../shared-components/HubProgressHeader';
import { useEffect, useState } from 'react';

export const TeamProgressAccordions = ({ hubData }: { hubData: TeamProjectHubResponse }) => {
  const [openAccordion, setOpenAccordion] = useState<string>();

  const { progress, userType, project } = hubData;
  const completedSteps = Object.values(progress).filter(
    (status) =>
      status === ProgressStepStatusEnum.success ||
      status === ProgressStepStatusEnum.inactive_in_progress,
  ).length;
  const totalSteps = Object.keys(progress).length;

  // handle default open to in progress and also allow user to manually open one accordion at a time
  const userCurrentStep = Object.entries(progress).find(
    ([, status]) =>
      status === ProgressStepStatusEnum.active_in_progress ||
      status === ProgressStepStatusEnum.inactive_in_progress,
  )?.[0];
  useEffect(() => {
    if (userCurrentStep) {
      setOpenAccordion(userCurrentStep);
    }
  }, [userCurrentStep]);
  const onAccordionToggle = (accordionKey: string) => (isOpen: boolean) => {
    if (isOpen) {
      setOpenAccordion(accordionKey);
    }
  };

  return (
    <>
      <HubProgressHeader
        completed={completedSteps}
        total={totalSteps}
        project={project}
        allowDateEdit={userType === 'PROFESSIONAL' && hubData.status === 'Matched'}
        includeDates={true} // team projects do not have a discovery phase
      />
      <Planning
        status={progress.planning}
        isTeam={true}
        userType={userType}
        projectId={project?.id}
        planningGuideUrl={hubData.planningGuideUrl}
        isOpen={openAccordion === 'planning'}
        onToggle={onAccordionToggle('planning')}
      />
      <Action
        status={progress.action}
        isTeam={true}
        userType={userType}
        projectId={project?.id}
        planningGuideUrl={hubData.planningGuideUrl}
        isOpen={openAccordion === 'action'}
        onToggle={onAccordionToggle('action')}
      />
      <Reflect
        status={progress.reflect}
        isTeam={true}
        userType={userType}
        surveyUrl={hubData.surveyUrl}
        storyUrl={hubData.storyUrl}
        isOpen={openAccordion === 'reflect'}
        onToggle={onAccordionToggle('reflect')}
      />
    </>
  );
};
